import RemoteCollection from "#root/utility/remote-collection";
import * as z from "zod";

export const ArticleListSchema = z.object({
  id: z.number(),
  name: z.string().default("--No Name--"),
  slug: z.string().nullish(),
  category: z.string().default("--No Category--"),
});

export const ArticleDetailSchema = ArticleListSchema.extend({
  page: z.string().nullish(),
}).loose();

export type ArticleListItem = z.infer<typeof ArticleListSchema>;
export type ArticleDetailItem = z.infer<typeof ArticleDetailSchema>;

export const articleCollection = new RemoteCollection("/api/article", ArticleListSchema, ArticleDetailSchema);

export const articleSlugCollection = new RemoteCollection("/api/article/bySlug", ArticleListSchema, ArticleDetailSchema);
